module.exports = __webpack_public_path__ + "img/模版自动更新.c4b21f2a.png";